<template>
  <div>
    <b-modal
      id="delete-group"
      hide-footer
    >
      <div class="d-flex flex-column align-items-center justify-content-center">
        <h4>
          Are you sure you want to delete {{ selectedGroupName }} group?
        </h4>
      </div>
      <div class="mt-1 d-flex justify-content-around">
        <b-button
          variant="primary"
          :disabled="loadingDeleteBtn"
          @click="deleteGroup"
        >
          <b-spinner
            v-if="loadingDeleteBtn"
            small
          />
          <span v-else>Delete</span>

        </b-button>
        <b-button
          variant="outline-danger"
          @click="$bvModal.hide('delete-group')"
        >
          Cancel
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import { BModal, BButton, BSpinner } from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'

export default {
  components: {
    BModal, BButton, BSpinner,
  },
  props: {
    group: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const loadingDeleteBtn = ref(false)
    const selectedGroupName = computed(() => (props.group ? props.group.name : ''))
    const deleteGroup = async () => {
      try {
        loadingDeleteBtn.value = true
        await ctx.root.$store.dispatch('groups/deleteGroup', props.group.id)
        ctx.root.$bvModal.hide('delete-group')
        ctx.emit('delete')
      } catch (error) {
        console.log(error)
      } finally {
        loadingDeleteBtn.value = false
      }
    }

    return {
      deleteGroup,
      selectedGroupName,
      loadingDeleteBtn,
    }
  },

}

</script>
